import Mission1Image from 'public/images/about/mission_1.jpg';
import Traveller1Image from 'public/images/about/better_traveller_1.jpg';
import Community1Image from 'public/images/about/better_community_1.jpg';
import Environment1Image from 'public/images/about/better_environment_1.jpg';
import CommunityImage from 'public/images/about/better_community_hero.jpg';
import Carbon1Image from 'public/images/about/carbon_1.jpg';
import ImageWithFallback from 'src/components/ImageWithFallback';
import ScrollableSection from 'src/components/ScrollableSection';
import { AppRoutes } from 'src/lib/routes';
import Link from 'next/link';

type PageName =
  | 'better_traveller'
  | 'better_community'
  | 'better_environment'
  | 'our_carbon'
  | 'sustainability';
const pages = [
  {
    id: 'sustainability',
    title: 'Sustainability 101',
    image: Community1Image,
    url: AppRoutes.sustainabilityRoute().toUrl()
  },
  {
    id: 'better_traveller',
    title: 'Better for Travellers',
    image: Traveller1Image,
    url: AppRoutes.betterTravellersRoute().toUrl()
  },
  {
    id: 'better_community',
    title: 'Better for Local Communities',
    image: CommunityImage,
    url: AppRoutes.betterLocalCommunitiesRoute().toUrl()
  },
  {
    id: 'better_environment',
    title: 'Better for the Environment',
    image: Environment1Image,
    url: AppRoutes.betterEnvironmentRoute().toUrl()
  },
  {
    id: 'our_carbon',
    title: 'Our Net-Zero Pledge',
    image: Carbon1Image,
    url: AppRoutes.ourCarbonCommitmentRoute().toUrl()
  },
]

type Props = {
  currentPage: PageName;
}

const AboutListCards: React.FC<Props> = ({ currentPage }) => {
  const actualPages = pages.filter(page => page.id !== currentPage)
  return (
    <ScrollableSection
      totalCount={actualPages.length}
      numRecord={actualPages.length}
      perSlide={3}
      renderTitle={() => (
        <h2 className="tw-text-center tw-font-semibold tw-font-styleSans tw-text-xl md:tw-text-2xl tw-mb-0 tw-leading-none md:tw-leading-none tw-py-4 tw-border-t tw-border-b tw-border-grey-lighter">
          Travel as a Force for Good Resources
        </h2>
      )}
      infinite={false}
      hasBlankCard={false}
      btnContainerClassName="tw-absolute tw-top-3 tw-right-0"
    >
      <div className="tw--mx-2 md:tw--mx-4 tw-flex tw-flex-nowrap">
        {actualPages.map((page) => (
          <Link legacyBehavior prefetch={false} key={page.id} href={page.url}>
            <a className="tw-block tw-w-60 md:tw-w-1/3 tw-px-2 md:tw-px-4 tw-flex-shrink-0 js-card-scrollable">
              <div className="tw-relative tw-mb-4" style={{ paddingBottom: '100%' }}>
                <ImageWithFallback src={page.image} alt="" fill className="tw-rounded-lg tw-border-2 tw-border-solid tw-border-brand-green tw-w-full tw-h-full tw-object-cover" />
              </div>
              <div className="tw-leading-none md:tw-leading-none tw-text-brand-navy tw-font-styleSans tw-text-center tw-font-semibold tw-text-xl md:tw-text-2xl">{page.title}</div>
            </a>
          </Link>
        ))}
      </div>
    </ScrollableSection>
  )
}

export default AboutListCards
